var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user_info)?_c('button',{class:_vm.is_collect ? 'active' : '',on:{"click":function($event){return _vm.is_collectShow()}}},[_vm._v("我的收藏")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }